import React, { PureComponent, Fragment } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  TableTitleBarChart,
  renderLegendsForTable,
  Error,
} from "./../Utils/Utils.js";

const metric = (cell, row, rowIndex, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

class AdsTableCreatives extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  titleWithChart = (cell, row) => {
    return (
      <TableTitleBarChart title={cell} row={row} bar_chart_data={row.data} />
    );
  };

  renderTable = (data, columns, chart) => {
    const { title } = this.props;

    // add unique ids
    data.forEach((d, i) => {
      let name = "";
      let bar_chart_data = [];

      // data for bar chart
      chart.forEach((bar) => {
        name = bar.split(" ").join("_").replace("%", "").toLowerCase();
        bar_chart_data.push({
          value: data[i][name].value,
          type: name,
        });
      });

      // eslint-disable-next-line no-sequences
      return (d.id = i), (d.data = bar_chart_data);
    });

    const table_columns = [
      {
        dataField: "ad_name",
        text: "Ad Name",
        style: { minWidth: "500px", maxWidth: "500px", textAlign: "left" },
        headerAlign: "left",
        formatter: (cell, row) => this.titleWithChart(cell, row),
        sort: true,
      },
      {
        dataField: "ctr",
        text: "CTR",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpc",
        text: "CPC",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpa",
        text: "CPA",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "cpm",
        text: "CPM",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "total_spent",
        text: "Total Spent",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "total_spend",
        text: "Total Spend",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { format: "$0.00a" },
        csvFormatter: (cell) =>
          selectFormat("csv_currency", cell && cell.value, "$0,0.00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_25",
        text: "Views 25%",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_50",
        text: "Views 50%",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views_75",
        text: "Views 75%",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "minutes_watched",
        text: "Minutes Watched",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "livestream_minutes",
        text: "Live Stream Minutes",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const selected_columns = [];

    const trClassFormat = (row, rowIndex) =>
      row.campaign
        ? "content-table-bar-chart__highlight"
        : "content-table-bar-chart__indent";

    columns.map((column) =>
      selected_columns.push(table_columns.find((o) => o.dataField === column))
    );

    const defaultSorted = [
      {
        dataField: "total_spent",
        order: "desc",
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <Fragment>
        {renderLegendsForTable(chart)}
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={selected_columns}
          rowClasses={trClassFormat}
          striped={false}
          hover={true}
          bordered={false}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: false,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              defaultSorted={defaultSorted}
              ref={(el) => (this.childRef = el)}
            />
          )}
        </ToolkitProvider>
      </Fragment>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, columns, chart } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data, columns, chart);
  }
}

export default AdsTableCreatives;
